import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propNumber, propStr } from '../../../helpers/custom-prop-types';
/**
 * プログレスバーを表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProgressBar = (props) => {
    const { className, progress } = props;
    const style = useMemo(() => ({
        width: `${progress > 100 ? 100 : progress}%`,
    }), [progress]);
    return (_jsx("div", Object.assign({ className: clsx('ui_progress_bar', className) }, { children: _jsx("div", Object.assign({ className: 'bar_inner' }, { children: _jsx("div", { className: 'bar_fill', style: style }) })) })));
};
ProgressBar.propTypes = {
    className: propStr(),
    progress: propNumber(),
};
ProgressBar.defaultProps = {
    className: '',
    progress: 0,
};
export default ProgressBar;
